module.exports = __webpack_public_path__ + "img/9.15cf27e6.png";